import React from 'react';

import useToggle from '@lyearn/core/hooks/useToggle';
import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import TagButton from '@/modules/skills/components/TagButton';

import SelectedSkills from './components/SelectedSkills';
import SelectSkillsDialog from './components/SelectSkillsDialog';
import { addSkillButtonStyles } from './styles';
import { AddSkillsProps } from './types';

function AddSkills(props: AddSkillsProps) {
  const { t } = useTranslation('Skills');
  const [open, { toggle }] = useToggle(false);
  const { title, description, skillIds, onChange, readonly } = props;

  return (
    <>
      <Stack className="w-full flex-wrap content-start gap-x-8 gap-y-12">
        {readonly ? null : (
          <TagButton
            className={cn(addSkillButtonStyles)}
            name={t('Skills:AddSkills.AddSkill')}
            onClick={toggle}
          />
        )}
        <SelectedSkills skillIds={skillIds} />
      </Stack>
      {open ? (
        <SelectSkillsDialog
          description={description}
          selectedSkillIds={skillIds}
          title={title}
          onAttach={onChange}
          onClose={toggle}
        />
      ) : null}
    </>
  );
}

export default React.memo(AddSkills);
